// extracted by mini-css-extract-plugin
export default {"favorites":"styles_favorites__WvfNw","favorites__list":"styles_favorites__list__OW2Eh","favorites__list-item":"styles_favorites__list-item__Wdzu7"};